"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pagination = exports.paginate = exports.PAGINATION_DEFAULT_INTERVAL = exports.PAGINATION_DEFAULT_PER = exports.PAGINATION_DEFAULT_PAGE = void 0;
var react_1 = __importDefault(require("react"));
var Stack_1 = require("../Stack");
var Page_1 = require("./Page");
exports.PAGINATION_DEFAULT_PAGE = 1;
exports.PAGINATION_DEFAULT_PER = 24;
exports.PAGINATION_DEFAULT_INTERVAL = 3;
var paginate = function (_a) {
    var _b = _a.page, page = _b === void 0 ? exports.PAGINATION_DEFAULT_PAGE : _b, _c = _a.per, per = _c === void 0 ? exports.PAGINATION_DEFAULT_PER : _c, total = _a.total;
    var totalPages = Math.ceil(total / per);
    var prevPage = page > 1 ? page - 1 : page;
    var nextPage = page < totalPages ? page + 1 : page;
    return { totalPages: totalPages, prevPage: prevPage, nextPage: nextPage };
};
exports.paginate = paginate;
var Pagination = function (_a) {
    var _b = _a.page, page = _b === void 0 ? exports.PAGINATION_DEFAULT_PAGE : _b, _c = _a.per, per = _c === void 0 ? exports.PAGINATION_DEFAULT_PER : _c, total = _a.total, href = _a.href, _d = _a.interval, interval = _d === void 0 ? exports.PAGINATION_DEFAULT_INTERVAL : _d, _e = _a.Page, Page = _e === void 0 ? Page_1.Page : _e, rest = __rest(_a, ["page", "per", "total", "href", "interval", "Page"]);
    var _f = (0, exports.paginate)({ page: page, per: per, total: total }), totalPages = _f.totalPages, prevPage = _f.prevPage, nextPage = _f.nextPage;
    if (totalPages <= 1)
        return null;
    return (react_1.default.createElement(Stack_1.Stack, __assign({ direction: "horizontal" }, rest),
        react_1.default.createElement(Stack_1.Stack, { direction: "horizontal" },
            react_1.default.createElement(Page, { pageNumber: 1, currentPage: page, href: href, per: per }, "A"),
            react_1.default.createElement(Page, { pageNumber: prevPage, currentPage: page, rel: "prev", href: href, per: per }, "past")),
        __spreadArray([], __read(Array(interval).keys()), false).map(function (i) {
            return page > i + 1 ? (react_1.default.createElement(Page, { key: page - (i + 1), pageNumber: page - (i + 1), currentPage: page, href: href, per: per, display: ["none", "none", "block"] }, page - (i + 1))) : undefined;
        })
            .filter(Boolean)
            .reverse(),
        react_1.default.createElement(Page, { pageNumber: page, currentPage: page, href: href, per: per }, page),
        __spreadArray([], __read(Array(interval).keys()), false).map(function (i) {
            return totalPages - page + 1 > i + 1 ? (react_1.default.createElement(Page, { key: page + (i + 1), pageNumber: page + (i + 1), currentPage: page, href: href, per: per, display: ["none", "none", "block"] }, page + (i + 1))) : undefined;
        })
            .filter(Boolean),
        react_1.default.createElement(Stack_1.Stack, { direction: "horizontal" },
            react_1.default.createElement(Page, { pageNumber: nextPage, currentPage: page, href: href, per: per, rel: "next" }, "next"),
            react_1.default.createElement(Page, { pageNumber: totalPages, currentPage: page, href: href, per: per }, "\u03A9"))));
};
exports.Pagination = Pagination;
exports.Pagination.displayName = "Pagination";
//# sourceMappingURL=Pagination.js.map